/*
 * Routes-auth.ts
 * Description: Includes the declaration of the
 * authentication routes for Vue Router
 */

// Importing components
import PageRegister from '@/pages/auth/PageRegister.vue';
import PageLogin from '@/pages/auth/PageLogin.vue';
import PageEditProfile from '@/pages/profile/PageEditProfile.vue';

const routesAuth = [
    // Defining the register page route
    {
        path: '/register',
        name: 'register',
        component: PageRegister,
    },
    // Defining the login page route
    {
        path: '/login',
        name: 'login',
        component: PageLogin,
    },
    // Defining the edit profile page route
    {
        path: '/profile',
        name: 'profile',
        component: PageEditProfile,
        meta: { requiresAuth: true },
    },
];
export default routesAuth;
